import type { FaireProductEntity } from "../../entity_types/product";

export const p_y7p4u2y2zw: FaireProductEntity = {
  token: "p_y7p4u2y2zw",
  type: "product",
  name: "Brass Tacks Blend",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl: "https://cdn.faire.com/fastly/0d72905be30838d0b9db920501a91df8bcb57148ee66bfe88df7cad02afca68c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/928ccd6b869002c730182a70b894ff685657bbffcb3f665df6979905ffd05601.png"
  ],
  priceDollars: 12.5,
  description: "The perfect blend of crispness to start your morning!",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:17.940Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
